import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=21642608&scoped=true"
import script from "./Material.vue?vue&type=script&lang=ts"
export * from "./Material.vue?vue&type=script&lang=ts"
import style0 from "./Material.vue?vue&type=style&index=0&id=21642608&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21642608",
  null
  
)

export default component.exports